// extracted by mini-css-extract-plugin
module.exports = {"withoutDialog":"SYa_A","withDialog":"_1r77K"};